import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link', 'dropdown', 'toggle']

  connect() {
    this.setActiveLink()
  }

  setActiveLink() {
    const current = window.location.pathname + window.location.search

    const activeLink = this.linkTargets.find((link) => {
      const href = link.getAttribute('href')
      if (!href || href.startsWith('#')) return false
      try {
        const url = new URL(href, window.location.origin)
        return url.pathname + url.search === current
      } catch {
        return href === current
      }
    })

    if (!activeLink) return

    const linkLi = activeLink.parentElement
    if (linkLi) linkLi.classList.add('active')

    const dropdown = this.dropdownTargets.find((d) => d.contains(activeLink))
    if (dropdown) {
      const toggle = this.toggleTargets.find((t) => dropdown.contains(t))
      const toggleLi = toggle?.parentElement
      if (toggleLi) toggleLi.classList.add('active')
    }
  }
}
